import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { ModalTarifasPage } from './modal-tarifas.page';

const routes: Routes = [
  {
    path: 'modal-tarifas',
    component: ModalTarifasPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [ModalTarifasPage]
})
export class ModalTarifasPageModule {}
